<section *ngIf="!sessionServiceType" [ngClass]="isSessionScreen ? 'sessionScreenHandle' : 'modal modal-poduct-type'">
  <div class="modal-dialog">
    <div class="modal-content">
      <a href="javascript:void(0);" class="modal-close" (click)="close($event)"><i class="icon">cross</i></a>
      <div class="modal-body">
        <h3 [ngClass]="d2dNotAvailable ? 'margin-bottom-12' : 'margin-bottom-32'">{{
          appCopy.panelHeader['titleServiceSelection'+selectedLanguage] }}</h3>
        <p *ngIf="d2dNotAvailable" class='margin-bottom-32'>{{
          appCopy.panelHeader['unavialbleSelectedD2dService'+selectedLanguage] }}</p>

        <ng-template
          [ngIf]="productAvailability && productAvailability.abcAvailable && productAvailability.ccdAvailable "
          [ngIfElse]="notD2D">
          <div class="modal-body__content">
            <div class="option-selection">
              <div class="option-selection__box" (click)="passProductType('abc')">
                <div class="flex-always flex--space-between">
                  <div>
                    <h2 class="option-selection-heading">{{
                      appCopy.panelHeader['titleDepartureService'+selectedLanguage] }}
                      {{flightDetails[0].departureAirport.airportCityName}}
                    </h2>
                    <h2 class="option-selection-subHeading">{{ appCopy.panelHeader['from'+selectedLanguage] }}
                      {{departurePrice}}
                    </h2>
                  </div>
                  <div class="option-selection-icon">
                    <img src="./images/modal/departure-service.svg" alt="">
                  </div>
                </div>

                <p class="option-selection-content">
                  {{ appCopy.panelHeader['contentServiceSelection'+selectedLanguage] }}
                </p>
              </div>
              <div class="option-selection__box" (click)="passProductType('ccd')">

                <div class="flex-always flex--space-between">
                  <div>
                    <h2 class="option-selection-heading">{{ appCopy.panelHeader['titleArrivalService'+selectedLanguage]
                      }} {{flightDetails[flightDetails.length-1].arrivalAirport.airportCityName}}
                    </h2>
                    <h2 class="option-selection-subHeading">{{ appCopy.panelHeader['from'+selectedLanguage] }}
                      {{arrivalPrice}}
                    </h2>
                  </div>
                  <div class="option-selection-icon">
                    <img src="./images/modal/arrival-service.svg" alt="">
                  </div>
                </div>
                <p class="option-selection-content">
                  {{ appCopy.panelHeader['contentArrivalService'+selectedLanguage] }}
                </p>
              </div>
            </div>

            <div class="divider-wrapper">
              <span>
                {{ appCopy.panelHeader['orText'+selectedLanguage] }}
              </span>
            </div>

            <div class="option-selection">
              <div class="option-selection__box" (click)="passProductType('d2d')">
                <div class="flex-always flex--space-between">
                  <div>
                    <h2 class="option-selection-heading">
                      {{ appCopy.panelHeader['titleD2DService'+selectedLanguage] }}
                    </h2>
                    <h2 class="option-selection-subHeading">{{ appCopy.panelHeader['from'+selectedLanguage] }}
                      {{d2dPrice}}
                    </h2>
                  </div>
                  <div class="option-selection-icon">
                    <img src="./images/modal/d2d-service.svg" alt="">
                  </div>
                </div>
                <p class="option-selection-content">
                  {{ appCopy.panelHeader['contentD2DService'+selectedLanguage] }}
                </p>
              </div>

            </div>
          </div>
        </ng-template>

        <ng-template #notD2D>
          <div class="modal-body__content">
            <ng-template [ngIf]="d2dNotAvailable" [ngIfElse]="hideD2dSection">

              <div class="option-selection">

                <div class="option-selection__box"
                  (click)="productAvailability.abcAvailable ? passProductType('abc') : false">

                  <div *ngIf="productAvailability && !productAvailability.abcAvailable"
                    class="option-selection__overlay"></div>

                  <div class="flex-always flex--space-between">
                    <div>
                      <h2 class="option-selection-heading">{{
                        appCopy.panelHeader['titleDepartureService'+selectedLanguage] }}
                        {{flightDetails[0].departureAirport.airportCityName}}
                      </h2>


                      <ng-template [ngIf]="productAvailability && productAvailability.abcAvailable"
                        [ngIfElse]="abcUnAvailable">
                        <h2 class="option-selection-subHeading">{{ appCopy.panelHeader['from'+selectedLanguage] }}
                          {{departurePrice}}</h2>
                      </ng-template>

                      <ng-template #abcUnAvailable>
                        <h2 class="option-selection-subHeading">
                          {{ appCopy.panelHeader['productNotAvailable'+selectedLanguage].replace('%s',
                          flightDetails[0].departureAirport.airportName.replace('Airport', '')) }}
                          <div class="bagtooltip">
                            <span class="icon-span icon-span-small tooltip-trigger-text">
                              <span class="icon-information icon-black icon_12">
                              </span>
                            </span>
                            <span class="tooltiptext tooltip-bottom"
                              [innerHTML]="appCopy.panelHeader['unfortunatelyMessageServiceSelection'+selectedLanguage].replace('%s', flightDetails[0].departureAirport.airportName.replace('Airport', ''))">
                            </span>
                          </div>
                        </h2>
                      </ng-template>

                    </div>
                    <div class="option-selection-icon">
                      <img src="./images/modal/departure-service.svg" alt="">
                    </div>
                  </div>

                  <p class="option-selection-content">
                    {{ appCopy.panelHeader['contentServiceSelection'+selectedLanguage] }}
                  </p>
                </div>

                <div class="option-selection__box"
                  (click)="productAvailability.ccdAvailable ? passProductType('ccd') : false">


                  <div *ngIf="productAvailability && !productAvailability.ccdAvailable"
                    class="option-selection__overlay"></div>

                  <div class="flex-always flex--space-between">
                    <div>
                      <h2 class="option-selection-heading">{{
                        appCopy.panelHeader['titleArrivalService'+selectedLanguage] }}
                        {{flightDetails[flightDetails.length-1].arrivalAirport.airportCityName}}
                      </h2>

                      <ng-template [ngIf]="productAvailability && productAvailability.ccdAvailable "
                        [ngIfElse]="ccdUnAvailable">
                        <h2 class="option-selection-subHeading">{{ appCopy.panelHeader['from'+selectedLanguage] }}
                          {{arrivalPrice}}
                        </h2>
                      </ng-template>

                      <ng-template #ccdUnAvailable>
                        <h2 class="option-selection-subHeading">
                          {{ appCopy.panelHeader['productNotAvailable'+selectedLanguage].replace('%s',
                          flightDetails[flightDetails.length-1].arrivalAirport.airportName.replace('Airport', '')) }}
                          <div class="bagtooltip">
                            <span class="icon-span icon-span-small tooltip-trigger-text">
                              <span class="icon-information icon-black icon_12">
                              </span>
                            </span>
                            <span class="tooltiptext tooltip-bottom"
                              [innerHTML]="appCopy.panelHeader['unfortunatelyMessageServiceSelection'+selectedLanguage].replace('%s', flightDetails[flightDetails.length-1].arrivalAirport.airportName.replace('Airport', ''))">
                            </span>
                          </div>

                        </h2>
                      </ng-template>
                    </div>
                    <div class="option-selection-icon">
                      <img src="./images/modal/arrival-service.svg" alt="">
                    </div>
                  </div>
                  <p class="option-selection-content">
                    {{ appCopy.panelHeader['contentArrivalService'+selectedLanguage] }}
                  </p>
                </div>

              </div>

              <div class="divider-wrapper">
                <span>
                  {{ appCopy.panelHeader['orText'+selectedLanguage] }}
                </span>
              </div>

              <!-- no D2Davailability -->
              <div class="option-selection">
                <div class="option-selection__box">
                  <div
                    *ngIf="productAvailability && (!productAvailability.ccdAvailable || !productAvailability.abcAvailable)"
                    class="option-selection__overlay"></div>

                  <div class="flex-always flex--space-between">
                    <div>
                      <h2 class="option-selection-heading">
                        {{ appCopy.panelHeader['titleD2DService'+selectedLanguage] }}
                      </h2>

                      <h2 class="option-selection-subHeading">
                        {{ appCopy.panelHeader['productNotAvailable'+selectedLanguage].replace('%s',
                        flightDetails[flightDetails.length-1].arrivalAirport.airportName.replace('Airport', '')) }}

                        <div class="bagtooltip">
                          <span class="icon-span icon-span-small tooltip-trigger-text">
                            <span class="icon-information icon-black icon_12">
                            </span>
                          </span>
                          <span class="tooltiptext tooltip-bottom"
                            [innerHTML]="appCopy.panelHeader['unfortunatelyMessageServiceSelection'+selectedLanguage].replace('%s', flightDetails[flightDetails.length-1].arrivalAirport.airportName.replace('Airport', ''))">
                          </span>
                        </div>

                      </h2>

                    </div>
                    <div class="option-selection-icon">
                      <img src="./images/modal/d2d-service.svg" alt="">
                    </div>
                  </div>
                  <p class="option-selection-content">
                    {{ appCopy.panelHeader['contentD2DService'+selectedLanguage] }}
                  </p>
                </div>

              </div>
            </ng-template>

            <ng-template #hideD2dSection>
              <div class="option-selection">
                <div class="option-selection__box"
                  (click)="productAvailability.abcAvailable ? passProductType('abc') : false">

                  <div *ngIf="productAvailability && !productAvailability.abcAvailable"
                    class="option-selection__overlay"></div>

                  <div class="flex-always flex--space-between">
                    <div>
                      <h2 class="option-selection-heading">{{
                        appCopy.panelHeader['titleDepartureService'+selectedLanguage] }}
                        {{flightDetails[0].departureAirport.airportCityName}}
                      </h2>


                      <ng-template [ngIf]="productAvailability && productAvailability.abcAvailable"
                        [ngIfElse]="abcUnAvailable">
                        <h2 class="option-selection-subHeading">{{ appCopy.panelHeader['from'+selectedLanguage] }}
                          {{departurePrice}}</h2>
                      </ng-template>

                      <ng-template #abcUnAvailable>
                        <h2 class="option-selection-subHeading">
                          {{ appCopy.panelHeader['productNotAvailable'+selectedLanguage].replace('%s',
                          flightDetails[0].departureAirport.airportName.replace('Airport', '')) }}
                          <div class="bagtooltip">
                            <span class="icon-span icon-span-small tooltip-trigger-text">
                              <span class="icon-information icon-black icon_12">
                              </span>
                            </span>
                            <span class="tooltiptext tooltip-bottom"
                              [innerHTML]="appCopy.panelHeader['unfortunatelyMessageServiceSelection'+selectedLanguage].replace('%s', flightDetails[0].departureAirport.airportName.replace('Airport', ''))">
                            </span>
                          </div>
                        </h2>
                      </ng-template>

                    </div>
                    <div class="option-selection-icon">
                      <img src="./images/modal/departure-service.svg" alt="">
                    </div>
                  </div>

                  <p class="option-selection-content">
                    {{ appCopy.panelHeader['contentServiceSelection'+selectedLanguage] }}
                  </p>
                </div>
              </div>

              <div class="option-selection">
                <div class="option-selection__box"
                  (click)="productAvailability.ccdAvailable ? passProductType('ccd') : false">


                  <div *ngIf="productAvailability && !productAvailability.ccdAvailable"
                    class="option-selection__overlay"></div>

                  <div class="flex-always flex--space-between">
                    <div>
                      <h2 class="option-selection-heading">{{
                        appCopy.panelHeader['titleArrivalService'+selectedLanguage] }}
                        {{flightDetails[flightDetails.length-1].arrivalAirport.airportCityName}}
                      </h2>
                      <ng-template [ngIf]="productAvailability && productAvailability.ccdAvailable "
                        [ngIfElse]="ccdUnAvailable">
                        <h2 class="option-selection-subHeading">{{ appCopy.panelHeader['from'+selectedLanguage] }}
                          {{arrivalPrice}}
                        </h2>
                      </ng-template>

                      <ng-template #ccdUnAvailable>
                        <h2 class="option-selection-subHeading">
                          {{ appCopy.panelHeader['productNotAvailable'+selectedLanguage].replace('%s',
                          flightDetails[flightDetails.length-1].arrivalAirport.airportName.replace('Airport', '')) }}
                          <div class="bagtooltip">
                            <span class="icon-span icon-span-small tooltip-trigger-text">
                              <span class="icon-information icon-black icon_12">
                              </span>
                            </span>
                            <span class="tooltiptext tooltip-bottom"
                              [innerHTML]="appCopy.panelHeader['unfortunatelyMessageServiceSelection'+selectedLanguage].replace('%s', flightDetails[flightDetails.length-1].arrivalAirport.airportName.replace('Airport', ''))">
                            </span>
                          </div>

                        </h2>
                      </ng-template>
                    </div>
                    <div class="option-selection-icon">
                      <img src="./images/modal/arrival-service.svg" alt="">
                    </div>
                  </div>
                  <p class="option-selection-content">
                    {{ appCopy.panelHeader['contentArrivalService'+selectedLanguage] }}
                  </p>
                </div>
              </div>
            </ng-template>
          </div>
        </ng-template>

        <!-- <div class="alert alert-success flex flex-always">
          <i class="icon margin-right-16">info</i>
          {{ appCopy.panelHeader['infoTextForServiceSelection'+selectedLanguage] }}
        </div> -->
      </div>
    </div>
  </div>
</section>
